var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiScribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 83",
    x: 7.89844,
    y: 4,
    width: 3.78947,
    height: 7.57521,
    rx: 1.89474,
    fill: "#2E3438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M13.5797 9.68457C13.5797 12.3109 11.6348 13.8357 9.71174 13.8255M6 9.68457C6.24036 12.5438 7.96709 13.8163 9.71174 13.8255M9.71174 13.8255V16.0004M7.23842 16.0004C7.46043 16.0004 10.6732 16.0004 12.2518 16.0004",
    stroke: "#2E3438",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiScribe);
export default __webpack_public_path__ + "static/media/aiScribe.bd4a1487bca53bb30ff5172965345b43.svg";
export { ForwardRef as ReactComponent };